export function Card({ title, subtitle, actions, children, className = '', bodyClassName = '' }) {
  return (
    <div className={`group relative flex flex-col overflow-hidden rounded-2xl bg-white/70 dark:bg-slate-900/60 backdrop-blur-xl shadow-card ring-1 ring-slate-900/5 dark:ring-white/10 border border-white/60 dark:border-white/10 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-card-hover ${className}`}>
      {/* Top glass sheen */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-24 bg-glass-sheen opacity-70 dark:opacity-0" />
      {(title || actions) && (
        <div className="relative flex shrink-0 flex-wrap items-center justify-between gap-2 px-4 sm:px-5 py-3.5 border-b border-slate-900/5 dark:border-white/10">
          {title && (
            <div className="min-w-0">
              <h3 className="font-semibold tracking-tight text-navy-800 dark:text-slate-100">{title}</h3>
              {subtitle && <p className="mt-0.5 text-xs font-normal text-slate-400 dark:text-slate-500">{subtitle}</p>}
            </div>
          )}
          {actions}
        </div>
      )}
      <div className={`relative flex-1 p-4 sm:p-5 ${bodyClassName}`}>{children}</div>
    </div>
  );
}
